<template>
    <div :class="classList">
        <div
            v-if="$auth.getUser().id !== companyUser.user.id && showAction"
            type="button"
            class="user-card__dropdown"
            @click="toggleMenu"
        >
            <common-icon name="three-horizontal-dots" size="large"></common-icon>
            <common-dropdown
                v-click-away="closeMenu"
                :isOpen="isDropdownOpen"
                :hasArrow="true"
                arrowPositionY="top"
                arrowPositionX="right"
            >
                <nav class="dropdown__menu">
                    <button type="button" @click="openChangeRoleModal()">
                        {{ $t('forms.company.user_card.buttons.change_role') }}
                    </button>
                    <button type="button" @click="openDeleteCompanyUserModal()">
                        {{ $t('common.microcopy.remove') }}
                    </button>
                </nav>
            </common-dropdown>
        </div>
        <div class="user-card__image">
            <common-user-avatar
                :withBorder="true"
                :user="companyUser.user"
                :shouldLeadToProfile="true"
                size="ultra-large"
            ></common-user-avatar>
        </div>
        <div class="user-card__name">{{ companyUser.user.firstName }} {{ companyUser.user.lastName }}</div>
        <div class="user-card__role">{{ userRole }}</div>
        <a :href="`mailto:${companyUser.user.email}`" class="user-card__email">{{ companyUser.user.email }}</a>
        <div class="user-card__phone">{{ companyUser.user.mobile }}</div>

        <change-role-company-user-modal
            v-if="isChangeRoleCompanyUserModalOpen"
            :companyId="companyId"
            :userId="companyUser.user.id"
            :showOnPublicProfile="companyUser.showOnPublicProfile"
            :showPublicProfile="companyUser.showPublicProfile"
            :companyRole="companyUser.companyRole"
            @close="closeChangeRoleModal()"
            @company-role-changed="companyRoleChanged($event)"
        ></change-role-company-user-modal>
        <yes-no-modal
            v-if="isDeleteCompanyUserModal"
            :heading="$t('modals.delete_company_user.title')"
            :isLoading="isLoading"
            @close="closeDeleteCompanyUserModal()"
            @accepted="deleteCompanyUser()"
        ></yes-no-modal>
        <div v-if="isSelected" class="user-card--selected__icon">
            <common-icon name="verified" size="small"></common-icon>
        </div>

        <div v-if="showOnPublicFlag" class="user-card__show">
            <checkbox-input
                :label="$t('forms.company.user_card.buttons.show_user')"
                :hasBigTapArea="true"
                :value="companyUser.showOnPublicProfile"
                @change="changeShowOnPublicProfile()"
            ></checkbox-input>
            <checkbox-input
                :label="$t('forms.company.user_card.buttons.show_public_profile')"
                :hasBigTapArea="true"
                :value="companyUser.showPublicProfile"
                @change="changeShowPublicProfile()"
            ></checkbox-input>
        </div>
        <div v-if="isSelectionAvailable" class="user-card--selected__checkbox">
            <checkbox-input
                :label="$t('forms.company.user_card.buttons.add_user')"
                :hasBigTapArea="true"
                :value="isSelected"
                @change="changeUserSelection()"
            ></checkbox-input>
        </div>
    </div>
</template>

<script>
    import ChangeRoleCompanyUserModal from 'components/modals/company/ChangeRoleCompanyUserModal'
    import YesNoModal from 'components/modals/YesNoModal'
    import UsersAPI from 'api/UsersAPI'
    import CheckboxInput from 'components/form-inputs/CheckboxInput'

    export default {
        components: {
            ChangeRoleCompanyUserModal,
            YesNoModal,
            CheckboxInput,
        },
        props: {
            companyUser: { type: Object, required: true },
            companyId: { type: Number, required: true },
            showAction: { type: Boolean, default: true },
            isSelectionAvailable: { type: Boolean, default: false },
            showOnPublicFlag: { type: Boolean, default: false },
        },
        data() {
            return {
                isLoading: false,
                isDropdownOpen: false,
                isChangeRoleCompanyUserModalOpen: false,
                isDeleteCompanyUserModal: false,
                isSelected: false,
            }
        },
        computed: {
            classList() {
                return {
                    'user-card': true,
                    'user-card--selected': this.isSelected,
                }
            },

            userRole() {
                return this.$t(`components.user.user_card.company_role.${this.companyUser.companyRole.toLowerCase()}`)
            },
        },
        methods: {
            toggleMenu() {
                this.isDropdownOpen = !this.isDropdownOpen
            },
            closeMenu() {
                this.isDropdownOpen = false
            },
            openChangeRoleModal() {
                this.isChangeRoleCompanyUserModalOpen = true
            },
            closeChangeRoleModal() {
                this.isChangeRoleCompanyUserModalOpen = false
            },
            companyRoleChanged(event) {
                this.closeChangeRoleModal()
                this.emitEvent({ name: 'company-role-changed', payload: event })
            },
            openDeleteCompanyUserModal() {
                this.isDeleteCompanyUserModal = true
            },
            closeDeleteCompanyUserModal() {
                this.isDeleteCompanyUserModal = false
            },
            deleteCompanyUser() {
                this.isLoading = true
                UsersAPI.deleteUserFromTheCompany({ userId: this.companyUser.user.id, companyId: this.companyId }).then(() => {
                    this.closeDeleteCompanyUserModal()
                    this.emitEvent({ name: 'company-user-deleted' })
                    this.isLoading = false
                })
            },
            changeUserSelection() {
                this.isSelected = !this.isSelected
                this.emitEvent({
                    name: 'user-selected',
                    payload: { isSelected: this.isSelected, id: this.companyUser?.user?.id },
                })
            },

            changeShowOnPublicProfile() {
                this.isLoading = true
                this.emitEvent({ name: 'company-show-user-changed', payload: this.companyUser })
                this.isLoading = false
            },

            changeShowPublicProfile() {
                this.isLoading = true
                this.emitEvent({ name: 'company-show-public-user-changed', payload: this.companyUser })
                this.isLoading = false
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/user/_user-card.scss';
</style>
